import { create } from "zustand";

const useModalStore = create((set) => ({
  isOpen: false,
  componentName: null,
  componentProps: {},
  contentStyle: "",

  openModal: ({ componentName, componentProps = {}, contentStyle = "" }) =>
    set(() => ({
      isOpen: true,
      componentName,
      componentProps,
      contentStyle,
    })),

  closeModal: () =>
    set(() => ({
      isOpen: false,
      componentName: null,
      componentProps: {},
      contentStyle: "",
    })),
}));

export default useModalStore;
